import { render, staticRenderFns } from "./EditSessionSurveyQuestion.vue?vue&type=template&id=20b2e266&"
import script from "./EditSessionSurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./EditSessionSurveyQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports